import { useEffect, useRef, useState } from 'react';
import { areaKey, type SearchArea } from '@/lib/areaSearch';

/** Jak długo chip świeci po zastąpieniu (prototyp Maćka 19.10). */
export const CZAS_BLYSKU_MS = 1400;

/**
 * Klucz obszaru, który przed chwilą ZASTĄPIŁ inny (osiedle za dzielnicę albo odwrotnie) — przez
 * ~1,4 s, potem null. Liczone z samej zmiany listy, nie z miejsca kliknięcia, więc działa dla
 * każdego wejścia: pola, listy „Dzielnice”, nakładki na telefonie, panelu i mapy. Prototyp Maćka
 * 19.10: zastąpienie widać po krótkim podświetleniu chipa w miejscu poprzednika, bez komunikatu
 * i bez „Cofnij”. Wspólne dla pola (SearchAreaBar), nakładki, wiersza Lokalizacja panelu i samej
 * listy dzielnic (WyborDzielnic, plan §1.91) — jeden zegar, jeden wygląd.
 */
export function useBlyskZastapienia(areas: SearchArea[], ms = CZAS_BLYSKU_MS): string | null {
  const [blysk, setBlysk] = useState<string | null>(null);
  const poprzednie = useRef(areas.map(areaKey));
  // Zegar w refie, nie w sprzątaniu efektu: kolejna zmiana listy w trakcie świecenia nie może
  // skasować zegara i zostawić chipa podświetlonego na stałe.
  const zegar = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(zegar.current), []);
  useEffect(() => {
    const teraz = areas.map(areaKey);
    const byly = poprzednie.current;
    poprzednie.current = teraz;
    const doszly = teraz.filter((k) => !byly.includes(k));
    const zniknely = byly.filter((k) => !teraz.includes(k));
    // Dokładnie jeden nowy obszar i co najmniej jeden zdjęty w tym samym kroku = zastąpienie.
    // Zwykłe dodanie (nic nie zniknęło) i zdjęcie (nic nie doszło) nie świecą.
    if (doszly.length !== 1 || zniknely.length === 0) return;
    setBlysk(doszly[0]);
    clearTimeout(zegar.current);
    zegar.current = setTimeout(() => setBlysk(null), ms);
  }, [areas, ms]);
  return blysk;
}

/**
 * Klasy chipa w podglądzie zastąpienia (przygaszony + przekreślony, zanim się kliknie) i po nim
 * (błysk). `tlo` to tło chipa w spoczynku: przy błysku jest PODMIENIANE, nie nadpisywane, bo dwie
 * klasy `bg-*` naraz rozstrzyga kolejność w arkuszu, a nie kolejność w atrybucie.
 */
export function klasyZastapienia({ przygaszony, blysk, tlo }: { przygaszony?: boolean; blysk?: boolean; tlo: string }): string {
  return `transition-[opacity,background-color,box-shadow] duration-700 ${blysk ? 'bg-primary/10 ring-1 ring-primary' : tlo} ${
    przygaszony ? 'line-through opacity-40 duration-200' : ''
  }`;
}
